export function compose(...funcs) {
  return val =>
    funcs
      .slice()
      .reverse()
      .reduce((v, f) => {
        return f(v)
      }, val)
}

export function get(val, keys, defaultVal) {
  for (let key of keys) {
    if (val == undefined) {
      break
    }
    val = val[key]
  }

  if (val == undefined) {
    return defaultVal
  }

  return val
}

const lib = {
  compose,
  get,
}

export default lib
